module.exports = __webpack_public_path__ + "img/PUC.becd34cc.png";